import React from 'react';
import { Button } from '@mui/material';
import history from 'services/history';

interface NewRecordButtonProps {
  // sempre "Novo/Nova + o que é criado", ex.: "Novo médico"
  label: string;
  to: string;
}

// Botão de criação do cabeçalho das listagens; no celular a criação fica no "+" da barra superior.
const NewRecordButton: React.FC<NewRecordButtonProps> = ({ label, to }) => (
  <Button variant="contained" color="primary" onClick={() => history.push(to)}>
    {label}
  </Button>
);

export default NewRecordButton;
